import { ApiResultState, initialApiObjectState } from "@app/root-store/api-result.state";
import { DealerBranding, DealerBrandingListItem } from "../model/dealer-branding";

export interface DealerBrandingState {
    /**
     *Provides CallState and result object for DealerBranding images
     *
     * @type {ApiResultState<{ string: DealerBranding }>}
     * @memberof DealerBrandingState
     */
    dealerBrandingImages: ApiResultState<{ [key: string]: DealerBranding }>;
    dealerBrandingImageList: ApiResultState<DealerBrandingListItem[]>;
}

export const initialDealerBrandingState: DealerBrandingState = {
    dealerBrandingImages: initialApiObjectState(),
    dealerBrandingImageList: initialApiObjectState(),
};

export const initialDealerBrandingImageListState: ApiResultState<DealerBrandingListItem[]> = initialApiObjectState();
